export default __webpack_public_path__ + "static/media/benefit_16@2x.3800a064.png";